var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isScheduled || _vm.$store.state.isAdminView
    ? _c(
        "div",
        {
          staticClass: "menu--item",
          class: { "menu--item-highlighted": _vm.item.mi_highlight === 1 },
          attrs: {
            "data-menu-item-id": _vm.item.mi_id,
            id: "menu--item-" + _vm.item.mi_id,
          },
        },
        [
          _c("h3", { staticClass: "menu--item_title" }, [
            _vm.steakSize.length
              ? _c("span", {
                  staticClass: "menu--item_size",
                  domProps: { innerHTML: _vm._s(_vm.steakSize) },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } }),
            _vm._v(" "),
            _vm.item.mi_description.length
              ? _c("span", {
                  staticClass: "menu--item_description",
                  domProps: { innerHTML: _vm._s(_vm.item.mi_description) },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.$store.state.isAdminView && _vm.item.normalizedSchedules.length
            ? _c("menu-schedules", {
                attrs: { "normalized-schedules": _vm.item.normalizedSchedules },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.item.tags, function (tag) {
            return _c("menu-tag", {
              key: tag.mt_id,
              attrs: { tag: tag, "menu-type": "visual" },
            })
          }),
          _vm._v(" "),
          _vm.item.price_display.length
            ? _c("menu-item-price", {
                attrs: {
                  "price-to-display": _vm.item.price_display,
                  "price-label": _vm.item.price_label,
                },
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }